function hasOpenDialogLayer() {
  return (
    document.querySelector('[role="dialog"]') !== null ||
    document.querySelector('[data-state="open"][role="dialog"]') !== null
  );
}

export function clearStaleInteractionLock() {
  if (typeof document === 'undefined') {
    return;
  }

  if (!hasOpenDialogLayer()) {
    document.body.style.pointerEvents = '';
    document.documentElement.style.pointerEvents = '';
  }
}

export function scheduleInteractionLockCleanup() {
  if (typeof window === 'undefined') {
    return;
  }

  window.setTimeout(clearStaleInteractionLock, 0);
}
